import { ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

const STEPS = [
    { n: "01", title: "Você chama", desc: "Envie pelo WhatsApp o que precisa." },
    { n: "02", title: "A gente entende", desc: "Nossa equipe analisa quantidade, material, acabamento e prazo." },
    { n: "03", title: "Você recebe o orçamento", desc: "Receba as opções e escolha a melhor solução." },
];

export const Process = () => (
    <section id="processo" data-testid="process-section" className="grain relative overflow-hidden bg-ink py-20 sm:py-28 lg:py-32 text-white">
        <div className="absolute -top-40 right-0 h-[420px] w-[420px] rounded-full bg-brand/10 blur-[140px]" />
        <div className="container-x relative">
            <SectionHead
                dark
                tag="06 — Como funciona"
                title="Do primeiro contato ao orçamento, sem complicação."
            />
            <div className="mt-14 grid gap-5 md:grid-cols-3">
                {STEPS.map((step, i) => (
                    <FadeUp key={step.n} delay={i * 0.1} className="h-full">
                        <div
                            data-testid={`process-step-${i}`}
                            className="group relative h-full overflow-hidden rounded-2xl border border-line bg-coal p-8 transition-colors duration-500 hover:border-brand/50"
                        >
                            <span className="font-display text-6xl font-extrabold tracking-tight text-white/10 transition-colors duration-500 group-hover:text-brand/25">
                                {step.n}
                            </span>
                            <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-white">{step.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-mist">{step.desc}</p>
                            {i < 2 && (
                                <span className="absolute right-6 top-8 hidden h-px w-10 bg-line md:block" />
                            )}
                        </div>
                    </FadeUp>
                ))}
            </div>
            <FadeUp delay={0.3}>
                <div className="mt-12 text-center">
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => track("whatsapp_click", { location: "process_section" })}
                        data-testid="process-cta"
                        className="group inline-flex items-center gap-3 rounded-full bg-brand px-9 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-brand-dark hover:shadow-[0_10px_40px_rgba(255,85,0,0.35)]"
                    >
                        Começar meu orçamento
                        <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                </div>
            </FadeUp>
        </div>
    </section>
);
